import { AuthService } from '../auth/auth.service';
import { Injector } from '@angular/core';
import { UserService } from '../services/user.service';

export function onAppInit(injector: Injector) {
  return () =>
    new Promise<void>((resolve, reject) => {
      const hash = document.location.hash.substr(2);
      const paths = hash.split('/');

      if (
        // Access by token - PO
        paths.length &&
        paths.length === 3 &&
        paths[0].toString() === 'order-headers' &&
        paths[1].toString() === 'edit'
      ) {
        injector
          .get(UserService)
          .loginUser({
            accessCode: paths[2],
          })
          .subscribe((result) => {
            if (result.token) {
              injector.get(AuthService).authenticate(result);
            }
            resolve();
          });
      } else if (
        // Access by token - TP
        paths.length &&
        paths.length === 3 &&
        paths[0].toString() === 'trading-partners' &&
        paths[1].toString().includes('edit')
      ) {
        if (injector.get(AuthService).isAuthenticated) {
          console.log('user is logged');
          injector.get(AuthService).loadPermissions();
          injector.get(AuthService).initExpDetection();

          resolve();
        } else {
          injector
            .get(UserService)
            .loginUser({
              accessCodeTP: paths[2],
            })
            .subscribe((result) => {
              if (result.token) {
                injector.get(AuthService).authenticate(result);
              }

              resolve();
            });
        }
      } else {
        // General Access
        if (injector.get(AuthService).isAuthenticated) {
          injector.get(AuthService).loadPermissions();
          injector.get(AuthService).initExpDetection();
        }
        resolve();
      }
    });
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/interceptors/initializer.interceptor.ts